import {
  Component,
  EventEmitter,
  HostListener,
  OnInit,
  Output,
} from "@angular/core";
import {
  faAngleDown,
  faAngleUp,
} from "@fortawesome/free-solid-svg-icons";
import { faBell } from "@fortawesome/free-regular-svg-icons";
import { GENERIC_PROFILE_PIC, STORAGE_KEYS } from "../../constants";
import { UserInfoService } from "../../services/user-info.service";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { AuthService } from "../../services/auth.service";
import { DialogService } from "../../services/dialog.service";
import { MatDialog } from "@angular/material/dialog";
import { ChangePasswordComponent } from "../change-password/change-password.component";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.css"],
})
export class NavbarComponent implements OnInit {
  constructor(
    private userInfoService: UserInfoService,
    private sanitizer: DomSanitizer,
    private authService: AuthService,
    private dialogService: DialogService,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.showMenu = window.innerWidth <= 640;
    this.userInfoService.userInfo$.subscribe((info) => {
      this.userInfo = info;
      const profilePic =
        this.userInfo[
          STORAGE_KEYS.USER_INFO["PROFILE_PIC"].sessionKey
        ] ?? GENERIC_PROFILE_PIC;
      this.profilePic =
        this.sanitizer.bypassSecurityTrustUrl(profilePic);
    });
  }

  @HostListener("document:click", ["$event"]) onDocumentClick(
    _event: Event,
  ) {
    this.showNotifications = false;
    this.showUserOptions = false;
  }

  @Output() clickMenu = new EventEmitter();

  faAngleUp = faAngleUp;
  faAngleDown = faAngleDown;
  faBell = faBell;

  showNotifications: boolean = false;
  showUserOptions: boolean = false;
  showMenu!: boolean;

  userInfo: { [key: string]: string | null } = {};

  profilePic: SafeUrl = this.sanitizer.bypassSecurityTrustUrl(
    GENERIC_PROFILE_PIC,
  );

  switchMenu() {
    this.showMenu = !this.showMenu;
    this.clickMenu.emit("data");
  }

  switchMid() {
    let midBar = document.getElementById("midBar");
    if (midBar?.classList.contains("on-menu-icon")) {
      midBar.classList.remove("on-menu-icon");
    } else {
      midBar?.classList.add("on-menu-icon");
    }
  }

  async onSignOut(): Promise<void> {
    this.showUserOptions = false;

    const confirmed = await this.dialogService.openConfirmDialog(
      "Sign Out",
      "Do you want to sign out?",
    );
    if (!confirmed) {
      return;
    }

    this.authService.logout().subscribe((response) => {
      const redirectUrl = response.d;
      if (redirectUrl) {
        window.location.href = redirectUrl;
      }
    });
  }

  openChangePassword(): void {
    this.showUserOptions = false;

    this.dialog.open(ChangePasswordComponent, {
      width: "600px",
      maxWidth: "calc(100vw - 32px)",
      position: {
        top: "42px",
      },
      disableClose: true,
    });
  }

  protected readonly STORAGE_KEYS = STORAGE_KEYS;
}
